import React, {useEffect} from 'react';
import ClipBoard from 'clipboard';
import { ReactComponent as IconLink } from '../../assets/images/icon_link.svg';
import cx from './index.module.scss';

const CopyButton = ({company}) => {
  useEffect(() => {
    const clipBoard = new ClipBoard(`.${cx.buttonCopy}`);
    clipBoard.on('success', () => window.alert('주소가 복사되었습니다!'));
    return () => {
      clipBoard.destroy();
    }
  }, []);

  return (
    <button
      className={cx.buttonCopy}
      data-clipboard-text={window.location.href}
    >
      <IconLink className={cx.iconLink} alt="URL 복사" />
      <span>{company ? '우리 회사 점수 공유하기' : '지금 동료에게 공유해보세요!'}</span>
    </button>
  )
};

export default CopyButton;
